import { createRoute, useLoaderData } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { unwrapPageInitialData, type PageInitialData } from "~/app/api/pageData";
import { storeFinderConfirmationPageQueryOptions } from "~/app/api/pageData/storeFinderConfirmationPageQuery";
import { StorefrontShellFrame } from "~/app/shell/StorefrontShellFrame";
import { useStorefrontShellProps } from "~/app/router/storefrontShellPropsContext";
import { rootRoute } from "~/app/router/rootRoute";
import { createStoreFinderConfirmationPage } from "~/pages/StoreFinderConfirmationPage/StoreFinderConfirmationPage";

function StoreFinderConfirmationRoute() {
  const result = useLoaderData({
    from: "/store-finder/confirmation",
  }) as PageInitialData<void>;
  const shellProps = useStorefrontShellProps();

  return (
    <StorefrontShellFrame variant={shellProps.variant} metadata={result.metadata}>
      {createStoreFinderConfirmationPage()}
    </StorefrontShellFrame>
  );
}

export async function loadStoreFinderConfirmationPageData(context: { queryClient: QueryClient }) {
  const result = await context.queryClient.ensureQueryData(storeFinderConfirmationPageQueryOptions());

  return unwrapPageInitialData(result);
}

export const storeFinderConfirmationRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/store-finder/confirmation",
  loader: async ({ context }) => loadStoreFinderConfirmationPageData(context),
  component: StoreFinderConfirmationRoute,
});
